import classNames from 'classnames'
import styles from './DashboardSectionBody.css'

const DashboardSectionBody = props => {
  const {
    className,
    children
  } = props

  const fullClassNames = classNames(
    styles.sectionBody,
    { [className]: !!className }
  )

  return (
    <div className={fullClassNames}>
      {children}
    </div>
  )
}

export default DashboardSectionBody
